import { Button, BUTTON_TYPES } from 'components/Button'
import { Typography } from 'components/Typography'
import { LABELS } from 'constants/txt'
import { isEmptyValue } from '../../utils'
import { RebateTier } from '../types'
import './styles.scss'

type TiersViewProps = {
  tiers: RebateTier[]
  isPurchaseVolume: boolean
  canEditTiers: boolean
  onEdit: () => void
}

const formatThreshold = (
  value: RebateTier['threshold'],
  isPurchaseVolume: boolean
) => {
  if (isEmptyValue(value)) return ''
  if (isPurchaseVolume) return `$${Number(value).toLocaleString('en-US')}`
  return `${value}%`
}

const formatRebateAmount = (value: RebateTier['amount']) =>
  isEmptyValue(value) ? '' : `${value}%`

const TiersView = ({
  tiers,
  isPurchaseVolume,
  canEditTiers,
  onEdit
}: TiersViewProps) => (
  <div className="tiers-view column">
    <div className="tiers-view__row tiers-view__header">
      <span />
      <Typography.Label>
        {isPurchaseVolume ? LABELS.THRESHOLD_DOLLARS : LABELS.THRESHOLD}
      </Typography.Label>
      <Typography.Label>{LABELS.REBATE_AMOUNT}</Typography.Label>
    </div>
    {tiers.map((tier, index) => (
      <div className="tiers-view__row" key={index}>
        <Typography.Body1>Tier {index + 1}</Typography.Body1>
        <Typography.Body1>
          {formatThreshold(tier?.threshold, isPurchaseVolume)}
        </Typography.Body1>
        <Typography.Body1>{formatRebateAmount(tier?.amount)}</Typography.Body1>
      </div>
    ))}
    {canEditTiers && (
      <Button
        className="tiers-view__edit-btn"
        type={BUTTON_TYPES.DEFAULT}
        upperCase
        htmlType="button"
        onClick={onEdit}
      >
        Edit tiers
      </Button>
    )}
  </div>
)

export default TiersView
